import { Injectable } from '@angular/core';
import { CombeniaService } from "../services/CombeniaService/CombeniaService";
import { CombeniaSyncService } from "../services/CombeniaService/CombeniaSyncService";
import { CombeniaItem } from "../services/CombeniaService/models/CombeniaItem";
import { AppConst } from "../services/CombeniaService/consts/AppConsts";
import { CombeniaAttribute } from '../services/CombeniaService/models/CombeniaAttribute';
import { BackendDataService } from '../services/backendDataService/backendDataService';
import { SERVICES } from '../constants/services';
import { BrandModel } from './BrandModel';
import { env } from '../environments/environment';

export const UserType = {
    KE_ADMIN:"KE Admin",
    KE_TRADE_MKT:"KE Trade Mkt",
    CUSTOMER:"Customer",
    KE_ACCOUNT:"KE Account Manager"
    
};
export const BS_TYPE = {
    KPS:"KPS",
    BS:"BS",
    NONE:"",
    
};

export class Triple {
    salesOrg: string;
    distrCh: string;
    countryCode: string;
    bestSellerType:string;
    derivedCanSeeTheme:boolean;
    constructor(obj: any) {
        this.salesOrg = obj["salesOrg"];
        this.distrCh = obj["distrCh"];
        this.countryCode = obj["countryCode"];
        this.bestSellerType=obj["bestSellerType"]?obj["bestSellerType"]: BS_TYPE.NONE;
        this.derivedCanSeeTheme = obj['derivedCanSeeTheme']?obj['derivedCanSeeTheme']:false;
    }
}




@Injectable()
export class UserModel {

    username: string;
    email: string;
    userDivisions: Array<Triple>
    currentDivision: Triple;
    active: boolean;
    user_type: string;
    showPricesSRP: boolean = false;
    showPricesWHS: boolean = false;
    showPOE: boolean = false;
    showFitting: boolean = false;
    rememberMe: boolean = false;
    profile:Array<string>=[];
    isSSOLogin: boolean = false;
    group:Array<string>=[];
    
    userBrands: Array<BrandModel>;
    constructor(public combenia: CombeniaService, public sync: CombeniaSyncService,
        public backend: BackendDataService
    ) {

    }


    isLoaded() {
        return this.username;
    }

    checkLoading(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.isLoaded()) {
                resolve();
            } else {
                this.loadData().then(() => {
                    resolve();
                });
            }
        });
    }

    //controlla se ci sono profili utente che non possono vedere la console
    isAllowed() {
        return true;
        //controllo sul tipo disabilitato
        /*this.user_type === UserType.COUNTRY_MANAGER || this.user_type === UserType.BACK_OFFICE
            || this.user_type === UserType.LIMITED_BACK_OFFICE || this.user_type === UserType.SUPER_ADMIN;*/
    }
    isCustomer(){
        
        return this.profile && this.profile.includes(UserType.CUSTOMER);
    }
    isMarketingManager(){
        //return true;
        return this.profile && (this.profile.includes(UserType.KE_TRADE_MKT) || this.profile.includes(UserType.KE_ADMIN));
    }
    isKeAccount() {
        return this.profile && this.profile.includes(UserType.KE_ACCOUNT);
    }

    //usata per controllare il ruolo customer. Per testare il tipo customer si può fare return true
    hasRole(roleName){
        // return true;
        return this.profile &&(this.profile.includes(roleName));
    }

    getClientId()
    {
       // return '0000100013'
        return this.username.padStart(10,'0')
    }

    async loadData(): Promise<any> {
        let credentials = this.sync.getUserCredentials();

        let res = await this.combenia.getItemsByCriteria({
            types: ['user'],
            attributes: [{
                name: 'username',
                value: credentials.username
            }]
        });
        let userItem: CombeniaItem = res[0];
        this.profile=[];
        this.group=[];
        userItem.attributeList.forEach((attr: CombeniaAttribute) => {
            this[attr.name] = attr.value;
        });
        this.userDivisions=[];
        await this.loadUserDivisions();
        var prefs = localStorage.getItem(this.username + "-" + AppConst.PREFERENCES);
        if (prefs) {
            var preferences = JSON.parse(prefs)
            this.showPricesSRP = preferences["showPricesSRP"];
            this.showPricesWHS = preferences["showPricesWHS"];
            this.showFitting = preferences["showFitting"];
            this.showPOE = preferences["showPOE"];
            var curDiv = new Triple(preferences["currentDivision"]);
            var finded = this.userDivisions.find((d: Triple) => {
                return d.salesOrg == curDiv.salesOrg && d.distrCh == curDiv.distrCh && d.countryCode == curDiv.countryCode;
            })
            if (finded) {
                this.currentDivision = curDiv;
            }
            else if (this.userDivisions.length > 0) {
                this.currentDivision = this.userDivisions[0];
                this.writePreferences();
            }
        }
        else if (this.userDivisions.length > 0) {
            this.currentDivision = this.userDivisions[0];
            this.writePreferences();
        }
        this.userBrands = await this.loadUserBrands();
    }

    writePreferences() {
        localStorage.setItem(this.username + "-" + AppConst.PREFERENCES, JSON.stringify({
            showPricesSRP: this.showPricesSRP,
            showPricesWHS: this.showPricesWHS,
            showFitting: this.showFitting,
            showPOE: this.showPOE,
            currentDivision: this.currentDivision,
            rememberMe: this.rememberMe
        }));
    }

    setDivision(division: Triple) {
        this.currentDivision = division;
        this.writePreferences();
    }

    setSettings(showPricesSRP, showPricesWHS, showPOE, showFitting) {
        this.showPricesSRP = showPricesSRP;
        this.showPricesWHS = showPricesWHS;
        this.showPOE = showPOE;
        this.showFitting = showFitting;
        this.writePreferences();
    }

    loadUserDivisions(): Promise<any> {
        if (this.userDivisions && this.userDivisions.length > 0)
            return new Promise((resolve, reject) => {
                resolve(this.userDivisions);
            });
        return this.backend.request(SERVICES["MARKET_AREAS"].list, {
            username: this.username
        }).then((data: any) => {
            this.userDivisions = [];
            if(data) {
                data.sort((a, b) => {
                    var a_triple = a.salesOrg + a.distrCh + a.countryCode;
                    var b_triple = b.salesOrg + b.distrCh + b.countryCode;
                    return a_triple > b_triple ? 1 : a_triple < b_triple ? -1 : 0
                })
    
                data.forEach((d) => {
                    var triple=new Triple(d);
                    var finded=this.userDivisions.find((t:Triple)=>{
                        return triple.salesOrg==t.salesOrg && triple.distrCh==t.distrCh && t.countryCode==triple.countryCode;
                    })
                    if(!finded)
                    {
                        this.userDivisions.push(triple);
                    }                   
                })
            }
            return data;
        });
    }

    loadUserBrands(): Promise<Array<BrandModel>> {
        let userCredential = localStorage.getItem(AppConst.USER_CREDENTIALS);
        let filter: any = {};
        if (userCredential) {
            filter.username = JSON.parse(userCredential).username;
        }

        return this.backend.request(SERVICES["BRAND"].list, filter).then(async (data: Array<BrandModel>) => {
           
            data.forEach((el) => {
                el.logo = env.imageUrl + el.code + '.png';
            })
            return data.sort((a, b) => {
                return a.position > b.position ? 1 : a.position < b.position ? -1 : 0;
            });
        }).catch((error) => {
            console.log(error);
            return null;
        });
    }
    getBrands(){
        if (this.showPOE) {
            return this.userBrands;
        }
        else
        {
            return this.userBrands.filter((b) => {
                return !b.semiHiddenBrand;
            })
        }
    }

    getBrandNameFromCode(code) {
        let brands = this.userBrands.find((el) => { return el.code === code });
        return brands.name;
    }

    getBrandLogoFromCode(code) {
        let brands = this.userBrands.find((el) => { return el.code === code });
        if(brands)
            return brands.logo;
        else 
            return null;
    }

    isUserNotDownload() {
        return this.group && this.group.includes("UserNoDownload");
    }
}
